module.exports = __webpack_public_path__ + "static/img/p-18.8a8aea6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-18.png
// module id = glao
// module chunks = 0